import React, { useState, useEffect } from "react";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { Payment } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  getroleName,
  getOrgId,
  getHeadId,
  GetCompanyLogo,
  HEADERS,
} from "../../pages/api";
import axios from "axios";
import logo from "../../images/leave-primary.png";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import CloseIcon from "@mui/icons-material/Close";

const MySidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleSubmenu = () => setIsSubmenuOpen(!isSubmenuOpen);
  const handleNavClick = () => setIsOpen(false);
  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => {
    if (!isOpen) setIsOpen(false);
  };

  // ✅ Get role and head safely
  const userRole = (getroleName() || "").toLowerCase();
  const isHead = getHeadId() === "true";

  const isAdmin = userRole === "admin";
  const isRootUser = userRole === "root user";
  const isUser = userRole === "user";
  const isSuperAdmin = userRole === "super user";
  const isHeadAndAdmin = isHead && isAdmin;

  // ✅ Debug logs (optional)
  // console.log("Sidebar role:", userRole);
  // console.log("Sidebar head:", isHead);

  const fetchCompanyLogo = async () => {
    const orgId = getOrgId();

    try {
      const formData = new FormData();
      formData.append("organization_id", orgId);

      const response = await axios.post(GetCompanyLogo, formData, {
        headers: { ...HEADERS },
        responseType: "arraybuffer",
      });

      const textDecoder = new TextDecoder("utf-8");
      const responseText = textDecoder.decode(response.data);

      try {
        const json = JSON.parse(responseText);
        if (json.response_code === "3001") {
          console.warn("No logo found, using fallback.");
          setCompanyLogo(logo);
          return;
        }
      } catch {}

      const blob = new Blob([response.data], { type: "image/png" });
      const reader = new FileReader();
      reader.onloadend = () => setCompanyLogo(reader.result);
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Error fetching company logo:", error);
      setCompanyLogo(logo); // fallback
    }
  };

  useEffect(() => {
    fetchCompanyLogo();
  }, []);

  return (
    <div>
      <div className="d-flex flex-row position-absolute logo-sidebar">
        <NavLink
          className="logo-title d-flex text-decoration-none align-items-center g-2"
          style={{ backgroundColor: "transparent" }}
        >
          {companyLogo && (
            <img
              src={companyLogo}
              alt="Company Logo"
              height="50"
              width="auto"
            />
          )}
        </NavLink>
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          {isOpen ? <CloseIcon /> : <MenuOpenIcon />}
        </button>
      </div>

      <div
        className={`nav__cont m-3 ${isOpen ? "open" : "close"}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ul className="nav">
          {!isSuperAdmin && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/dashboard"
                onClick={handleNavClick}
              >
                <DashboardOutlinedIcon className="side-icon" />
                <span>Dashboard</span>
              </NavLink>
            </li>
          )}

          {(isAdmin || isRootUser || isHead) && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/users"
                onClick={handleNavClick}
              >
                <PersonOutlineIcon className="side-icon" />
                <span>Users</span>
              </NavLink>
            </li>
          )}

          {(isAdmin || isRootUser || isHead || isUser) && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/leave-navigation"
                onClick={handleNavClick}
              >
                <MailOutlineIcon className="side-icon" />
                <span>Leave</span>
              </NavLink>
            </li>
          )}

          {isHead && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/approval"
                onClick={handleNavClick}
              >
                <ListAltOutlinedIcon className="side-icon" />
                <span>Approval</span>
              </NavLink>
            </li>
          )}

          {isSuperAdmin && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/dashboard-super-admin"
                onClick={handleNavClick}
              >
                <DashboardOutlinedIcon className="side-icon" />
                <span>Dashboard Super</span>
              </NavLink>
            </li>
          )}

          {(isAdmin || isRootUser || isHead || isHeadAndAdmin) && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/Leave-Request"
                onClick={handleNavClick}
              >
                <CalendarMonthOutlinedIcon className="side-icon" />
                <span>View Leave</span>
              </NavLink>
            </li>
          )}

          {(isAdmin || isRootUser || isHead || isHeadAndAdmin) && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/report"
                onClick={handleNavClick}
              >
                <DescriptionOutlinedIcon className="side-icon" />
                <span>Report</span>
              </NavLink>
            </li>
          )}

          {/* {isRootUser && (
            <li className="nav__items">
              <NavLink
                className="navi-link d-flex rounded"
                end
                to="/billing"
                onClick={handleNavClick}
              >
                <Payment className="side-icon" />
                <span>Billing</span>
              </NavLink>
            </li>
          )} */}

          {(isAdmin || isRootUser || isHeadAndAdmin) && (
            <li
              className="nav__items settings-item"
              onMouseEnter={toggleSubmenu}
              onMouseLeave={toggleSubmenu}
            >
              <div className="navi-link d-flex rounded">
                <SettingsOutlinedIcon className="side-icon" />
                {isOpen && <span>Setting</span>}
              </div>
              {isSubmenuOpen && (
                <ul className={`submenu ${isOpen ? "open" : ""}`}>
                  <li>
                    <NavLink
                      className="navi-link1 d-flex rounded submenu-link"
                      end
                      to="/user-setting-dashboard"
                      onClick={handleNavClick}
                    >
                      <span className="tick-symbol">✔</span>
                      <span className="subb">User Setting</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="navi-link1 d-flex rounded submenu-link"
                      end
                      to="/leave-page"
                      onClick={handleNavClick}
                    >
                      <span className="tick-symbol">✔</span>
                      <span className="subb">Leave Setting</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="navi-link1 d-flex rounded submenu-link"
                      end
                      to="/other-setting"
                      onClick={handleNavClick}
                    >
                      <span className="tick-symbol">✔</span>
                      <span className="subb">Other Setting</span>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MySidebar;
